import {
	CheckCircleIcon,
	InformationCircleIcon,
} from '@heroicons/react/24/solid';
import { Form, useLoaderData } from 'react-router-dom';

export async function loader({ request }) {
	// TODO do actual programs search
	const url = new URL(request.url);
	const categories = url.searchParams.getAll('category');
	const zipCode = url.searchParams.get('zipCode');
	return { categories, zipCode };
}

const ServicesRequested = () => {
	// eslint-disable-next-line no-unused-vars
	const { categories, zipCode } = useLoaderData();
	return (
		<div className="page services-requested">
			<div className="sm:mx-auto sm:w-full sm:max-w-sm">
				<h2>Services Requested</h2>
				<h4>
					49456 <strong>Muskegon County</strong>
				</h4>
			</div>
			<div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
				<Form method="get" action="/register">
					<h3>Final Selections</h3>
					<div>Services Cart</div>
					{categories.map((category) => (
						<div
							key={category}
							className="p-4 mt-6 text-white rounded bg-primary-700"
						>
							<div className="flex flex-row items-center gap-4">
								<div className="block w-8 h-8">
									<CheckCircleIcon />
								</div>
								<div className="flex-1 text-lg font-bold">
									Mission for Area People
								</div>
							</div>
							<div className="mt-2 font-bold">{category}</div>
							<div>Program 1, Program 2...</div>
							<div className="flex flex-row items-center">
								<div className="flex-1 text-xs font-bold">
									Eligibility Verified
								</div>
								<div>
									<InformationCircleIcon className="block w-6 h-6" />
								</div>
							</div>
						</div>
					))}
					<div className="mt-6">
						<input type="hidden" name="zipCode" value={zipCode} />
						<button className="text-white btn btn-primary btn-sm btn-block">
							Confirm &amp; Continue
						</button>
					</div>
				</Form>
			</div>
		</div>
	);
};

export default ServicesRequested;
